import { useGetPermissionsQuery } from '@lotta/self-service/lottery-fe/data-access-state';
import { getUserPermissions } from '@lotta/self-service/lottery-fe/util-utilities';
import { useNavigateWithLocale } from '@lotta/self-service/lottery-fe/feature-hooks';
import { useEffect } from 'react';
import { useParams, Outlet } from 'react-router-dom';
import type { LocaleParams } from '@lotta/self-service/lottery-fe/types-router';
import Loading, { LoadingBall } from '@ingka/loading';
import styles from './RoleVerification.module.scss';

export type RoleVerificationProps = {
  allowedRoles: string[];
};

export const RoleVerification = (props: RoleVerificationProps) => {
  const { allowedRoles } = props;
  const { data, isLoading } = useGetPermissionsQuery({});
  const { countryCode } = useParams<LocaleParams>() as LocaleParams;
  const navigate = useNavigateWithLocale();

  useEffect(() => {
    if (!isLoading && data) {
      const userRoles = getUserPermissions(countryCode.toUpperCase(), data.permissions);

      if (!userRoles.some((role) => allowedRoles.includes(role))) {
        navigate('/');
      }
    }
  }, [isLoading, data, countryCode, navigate, allowedRoles]);

  return (
    <div className={styles['container']}>
      {isLoading ? (
        <Loading>
          <LoadingBall />
        </Loading>
      ) : (
        <Outlet />
      )}
    </div>
  );
};
